import { INetworkProvider } from './networkProvider.types';

/**
 * Default (web) network provider: adds no fields of its own to `environment.data` and takes
 * `requestUri` straight from the player init options.
 *
 * Lives apart from `apiService.ts` because that module is the build-time swap target — other
 * providers extend this object instead of importing the service they may be replacing.
 */
export const webProvider: INetworkProvider = {
    platform: 'Web',
};
